import React, { Fragment } from 'react';
import Select from 'react-select';
import axios from 'axios';
import constants from '../util/constants';
import wrapWithApiData from '../wrapWithApiData';
import CustomerData from './CustomerData';
import CustomerAllocation from './CustomerAllocation';
import NPPanel from '../NPPanel';
import './style.scss';
import LoadingSpinner from '../LoadingSpinner';
import { Col, Row, Form, FormGroup, Button, InputGroup, FormControl } from 'react-bootstrap';
import * as Grants from '../util/grants';
import { hasGrant } from '../util/grantHelper';
import apiHelper from '../util/api.helper.js';
import CustomerReservation from './CustomerReservation/index';
import AllocationWeekTotals from '../Allocation/AllocationWeekTotals/index.js';
import * as Convert from '../util/unitConversion';
import CustomerExternal from './CustomerExternal/index.js';

const { API_BASE_URL } = constants;

class CustomerProfile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            CustomerData: {},
            AllocationWrapper: {},
            TransportationData: [],
            UserType: window.sessionStorage.getItem('UserType'),
            successMessage: 'Allocation updated.',
            success: false,
            errorMessage: '',
            showError: false,
            selectedValue: '',
            isLoading: false,
            legalEntity: '',
            customer: null,
            customers: [],
            denyFilter: false,
            isCustomer: false,
            TotalsWeekView: {},
            selectedYear: null,
            selectedMachines: [],
            availableYears: [],
            dropdownStyleSmall: {
                valueContainer: (provided) => ({
                    ...provided,
                    minWidth: '50px'
                }),
            },
            ExternalConverterData: [],
        }

        this.prependToList = this.prependToList.bind(this);
        this.changeCustomerFilter = this.changeCustomerFilter.bind(this);
        this.getCustomerCodes = this.getCustomerCodes.bind(this);
        this.initializeAllocationFilters().then(() => {
            this.getCustomerCodes(this.props.header);
        });
    }

    refresh() {
        this.setState({});
    }

    initializeAllocationFilters() {
        // Generate available years: last 5 years + next year
        const currentYear = new Date().getFullYear();
        const availableYears = [];
        for (let i = 1; i >= -5; i--) {
            const year = currentYear + i;
            availableYears.push({ label: year, value: year });
        }

        // Fetch allocation settings to get the default year
        return axios.get(API_BASE_URL + 'Allocation/GetAllocationSettings', { headers: this.state.header })
            .then(response => {
                const data = response.data;
                let defaultYear = currentYear;
                
                // Use the year from the API if available
                if (data && data.Year) {
                    defaultYear = parseInt(data.Year, 10);
                }
                
                this.setState({
                    availableYears: availableYears,
                    selectedYear: { label: defaultYear, value: defaultYear }
                });
            })
            .catch(error => {
                // Fallback to current year if API call fails
                this.setState({
                    availableYears: availableYears,
                    selectedYear: { label: currentYear, value: currentYear }
                });
            })
            .then(() => {
                return axios.get(API_BASE_URL+'Allocation/GetAllocationFilters',{headers: this.state.header})
                    .then(response => {
                        const availableMachines = response.data.Machines.map(m => ({ label: m, value: m }));
                        this.setState({ availableMachines})
                    })
                    .catch(error => {
                        this.setState({ availableMachines: [] })
                    });
            });
    }

    getCombo(_caption, _stateObj, _onChange, _placeHolder, _options, _clearable = true, disabled = false) {
        return (
            <InputGroup className="margin-left-5 margin-top-3" bsSize="sm">
                <Select isSearchable={true} isClearable={_clearable} resetValue='' style={{ zIndex: 10 }}
                    styles={{
                        valueContainer: (provided) => ({
                            ...provided,
                            minWidth: '120px'
                        }),
                    }}
                    isDisabled={disabled}
                    value={this.state[_stateObj] || null} onChange={(item) => _onChange(item, _stateObj)}
                    options={_options} placeholder={_placeHolder} />
            </InputGroup>
        );
    }

    prependToList(list, type) {
        let item = {};

        list = [item, ...list];
        return list;
    }

    changeCustomerFilter(item, yearOverride = null, machineOverride = null) {
        let self = this;
        let customer = '?ccr=' + item?.value;
        const year = yearOverride !== null ? yearOverride : this.state.selectedYear?.value;
        const machines = machineOverride !== null ? machineOverride : this.state.selectedMachines?.map(m => m.value);
        if (year) {
            customer += '&year=' + year;
        }
        if (machines && machines.length > 0) {
            customer += '&machines=' + machines.join(',');
        }
        this.setState({
            isLoading: true,
            customer: item
        });

        axios.get(API_BASE_URL + 'CustomerProfile/GetCustomerProfile' + customer, { headers: this.state.header })
            .then(response => {
                let data = response.data;
                if (data.ErrorMessage === null) {
                    this.setState({
                        isLoading: false,
                        showError: false,
                        success: true,
                        CustomerData: data.CustomerData,
                        TransportationData: data.TransportationData,
                        AllocationWrapper: data.AllocationWrapper,
                        legalEntity: data.AllocationWrapper.LegalEntity,
                        selectedValue: data.CustomerData.CLIENT_CODE_REGIONAL,
                        customer: item,
                        TotalsWeekView: data.TotalsWeekView,
                        ExternalConverterData: data.ExternalConverterData,
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        showError: true,
                        success: false,
                        errorMessage: data.ErrorMessage,
                        TransportationData: [],
                        CustomerData: {},
                        AllocationWrapper: {},
                        selectedValue: '',
                        customer: null,
                        TotalsWeekView: {},
                        ExternalConverterData: [],
                    });
                }
            })
            .catch(error => {
                let data = error.response.data;
                let message = error.response.data.ExceptionMessage ? error.response.data.ExceptionMessage : (error.Message ? error.Message : "Error fetching customer information.");
                this.setState({
                    isLoading: false,
                    showError: true,
                    success: false,
                    errorMessage: message,
                    CustomerData: {},
                    AllocationWrapper: {},
                    selectedValue: '',
                    customer: null,
                    TotalsWeekView: {},
                    ExternalConverterData: [],
                });
            });
    }

    async getCustomerCodes(headers) {
        if (this.state.user && this.state.user.Settings.UserType === '3') {
            return;
        }
        let self = this;
        if (!headers) {
            headers = this.state.header;
        }

        await apiHelper.getCustomerFilter(headers)
            .then(res => {
                res = self.prependToList(res, 'Customer');
                self.setState({ loaded: true, customers: res }, () => {
                    const ccr = self.props.match && self.props.match.params && self.props.match.params.ccr;
                    const year = self.state.selectedYear?.value;
                    if (ccr) {
                        // Find the customer object matching the ccr
                        const selectedCustomer = res.find(c => c.value === ccr);
                        if (selectedCustomer) {
                            self.changeCustomerFilter(selectedCustomer, year);
                        } else {
                            // fallback if not found
                            self.changeCustomerFilter({ value: ccr }, year);
                        }
                    }
                });
            })
            .catch((e) => {
                self.setState({ loaded: true, showError: true })
            });
    }

    getCustomerSearch() {
        let errorMessage = this.state.errorMessage;
        let showError = this.state.showError;

        const { denyFilter, isCustomer } = this.state;
        const customer = this.state.user && this.state.user.Settings && this.state.user.Settings.UserType === '3' ? true : false;
        return (

            <Form inline className="searchForm" autoComplete="off" onSubmit={(evt) => { evt.preventDefault(); this.search() }} onReset={(evt) => { evt.preventDefault(); }}>
                <Col sm={12} className="react-select">
                    <FormGroup>
                        {isCustomer == false &&
                            <div className={denyFilter ? "pull-left error" : "pull-left"}>
                                {this.getCombo('Customer', "customer", (item) => this.changeCustomerFilter(item), 'Select Customer', this.state.customers, true, customer)}
                            </div>
                        }
                    </FormGroup>
                </Col>
                <Col sm={12} className="flex flexSpan">
                    <FormGroup>
                        {showError &&
                            <span className="errorMessage">
                                {errorMessage}
                            </span>
                        }
                    </FormGroup>
                </Col>
            </Form>

        );
    }

    checkSessionStorageId() {
        var customer = window.sessionStorage.getItem("customerId");
        var year = window.sessionStorage.getItem("allocationYear");
        if (customer != null) {
            // If sessionStorage is set as a string, convert to object with the string as a value,
            // since changeCustomerFilter(customer) checks for customer.value 
            if (typeof customer != "object") {
                customer = {
                    value: customer
                }
            }

            this.changeCustomerFilter(customer, year ? parseInt(year, 10) : null);
            window.sessionStorage.removeItem("customerId");
            window.sessionStorage.removeItem("allocationYear");
        }
    }

    handleSearch = (evt) => {
        if (evt) evt.preventDefault();
        const { customers, CustomerData, selectedYear, selectedMachines } = this.state;

        const ccr = CustomerData && CustomerData.CLIENT_CODE_REGIONAL;
        const selectedCustomer = customers.find(c => c.value === ccr) || { value: ccr };
        this.changeCustomerFilter(
            selectedCustomer,
            selectedYear?.value,
            selectedMachines?.map(m => m.value)
        );
    }

    render() {
        let ccr = this.state.CustomerData && this.state.CustomerData.CLIENT_CODE_REGIONAL;
        const userType = window.sessionStorage.getItem('UserType') || this.state.UserType;

        if (this.state.isLoading) {
            return (
                <NPPanel>
                    {this.getCustomerSearch()}
                    <LoadingSpinner isLoading={true} />
                </NPPanel>
            );
        }
        else {
            return (
                <div>
                    <NPPanel>
                        {this.getCustomerSearch()}
                        <CustomerData customerData={this.state.CustomerData} />
                    </NPPanel>
                    {userType === '1' && <NPPanel>
                        <Row>
                            <CustomerReservation ccr={ccr} header={this.state.header} />
                        </Row>

                    </NPPanel>}

                    {hasGrant(Grants.TYPES.CustomerProfile_ViewCustomerAllocation) &&
                        <NPPanel>
                            <Row>
                                <Col sm={12} className="react-select">
                                    <Form onSubmit={this.handleSearch}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <InputGroup className="margin-left-5 margin-top-3" bsSize="sm">
                                                <InputGroup.Addon style={{ width: "65px" }}>Year</InputGroup.Addon>
                                                <Select searchable={true}
                                                    styles={this.state.dropdownStyleSmall}
                                                    isClearable={false}
                                                    options={this.state.availableYears}
                                                    menuPortalTarget={document.body}
                                                    value={this.state.selectedYear}
                                                    onChange={evt => {
                                                        this.setState({ selectedYear: evt });
                                                    }}
                                                />
                                            </InputGroup>
                                            { userType === '1' &&
                                                <InputGroup>
                                                    <InputGroup.Addon style={{ width: "65px" }}>Machine</InputGroup.Addon>
                                                        <Select searchable={true}
                                                            isMulti
                                                            styles={this.state.dropdownStyleSmall}
                                                            isClearable={true}
                                                            options={this.state.availableMachines}
                                                            value={this.state.selectedMachines}
                                                            menuPortalTarget={document.body}
                                                            onChange={evt => {
                                                                this.setState({ selectedMachines: [...evt]});
                                                        }} />
                                                </InputGroup>
                                            }
                                            <Button type="submit" bsStyle="primary">
                                                Search
                                            </Button>
                                        </div>
                                    </Form>
                                </Col>
                            </Row>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                {this.state.TotalsWeekView && this.state.TotalsWeekView.Months && this.state.TotalsWeekView.Months.length > 0 &&
                                    <div style={{ marginTop: '18px' }}>
                                        <AllocationWeekTotals apiToken = {this.props.apiToken} data = {this.state.TotalsWeekView} userType = {userType} />
                                    </div>
                                }
                                {userType === '1' && this.state.ExternalConverterData?.length > 0 &&
                                    <div style={{ display: 'flex', gap: '16px' }}>
                                        {this.state.ExternalConverterData.map((item, index) => (
                                            <div key={index} style={{ width: 'fit-content' }}>
                                                <CustomerExternal apiToken = {this.props.apiToken} data = {item} />
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </NPPanel>
                    }

                    {this.checkSessionStorageId()}


                </div>
            )
        }
    }
}

export default CustomerProfile;